<ng-template #giftModal let-modal>
    <div class="modal-content" *ngIf="giftList">
        <div class="modal-header" style="border-bottom: 1px solid #DEDEDE; padding: 25px;">
            <div class="d-flex justify-content-between align-items-center w-100">
                <div class="modal-title" style="font-size: 24px;">Thêm quà vào giỏ</div>
                <app-button [class]="'btn btn-close btn-sm'" [spinner]="false" [id]="'login_modal_close_btn'"
                    (click)="modal.dismiss('Cancel')">
                    <i class="ri-close-line"></i>
                </app-button>
            </div>
        </div>
        <div class="modal-body p-0">
        <div style="padding: 32px 25px;">
            <div class="d-flex align-items-center gap-2" style="padding-bottom: 20px;">
            <span style="font-size: 20px; font-weight: 600;">Danh sách quà đã đổi từ xu</span>
            </div>

            <div *ngIf="giftList.length > 0; else noGifts" [class]="gridClass">
            <ng-container *ngFor="let gift of giftList">
                <app-exchanged-gift [gift]="gift"></app-exchanged-gift>
            </ng-container>
            </div>

            <ng-template #noGifts>
            <div class="text-center text-muted py-5">
                <div class="mt-3" style="font-size: 16px;">Danh sách quà đã đổi của bạn đang trống. Hãy sử dụng xu để đổi quà ngay !</div>
            </div>
            </ng-template>
        </div>
        </div>
    </div>
</ng-template>